import getEnv, { Environment } from '@/utils/environment';

const env = getEnv();

export const GTM_ID = env === Environment.PROD ? 'GTM-NWCXLCP' : 'GTM-5BFXG7T';
